/* =========================================================================
   KENZA · COMING SOON OVERLAY
   - Add body class to lock scroll + hide other content (CSS does the work)
   - Submit button loading state
   - Scroll to top when success state shows
   ========================================================================= */

(function () {
  'use strict';

  var BODY_CLASS = 'kenza-cs-active';

  function initOverlay() {
    var overlay = document.querySelector('[data-kenza-cs]');
    if (!overlay) {
      // No overlay = make sure body class is removed
      document.body.classList.remove(BODY_CLASS);
      return;
    }

    /* Add body class — CSS handles the rest (scroll lock + hide siblings) */
    document.body.classList.add(BODY_CLASS);

    /* Scroll overlay to top if showing success state */
    var success = overlay.querySelector('[data-kenza-cs-success]');
    if (success) {
      setTimeout(function () {
        overlay.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }

    /* Submit button loading state */
    var form = overlay.querySelector('.kenza-cs__form');
    var submit = overlay.querySelector('.kenza-cs__submit');
    if (form && submit) {
      form.addEventListener('submit', function () {
        submit.disabled = true;
        var textEl = submit.querySelector('.kenza-cs__submit-text');
        if (textEl) {
          textEl.textContent = 'Versturen...';
        }
        submit.style.opacity = '0.7';
        submit.style.cursor = 'wait';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOverlay);
  } else {
    initOverlay();
  }

  /* Shopify section editor — re-init when section is reloaded */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-kenza-cs]')) {
      initOverlay();
    }
  });

  /* When overlay is removed in the editor, remove the body class */
  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector('[data-kenza-cs]')) {
      document.body.classList.remove(BODY_CLASS);
    }
  });
})();